<template>
    <v-dialog 
        v-model="previewActive" 
        v-if="state.preview"
        transition="dialog-top-transition" 
        :max-width="!state.isMobile ? '60vw' : ''"
        @click:outside="closePreview"
    >
        <template v-slot:activator="{ on, attrs }">
            <v-btn outlined class="preview-btn" v-bind="attrs" v-on="on">
                <slot name="activator">
                    Preview
                    <font-awesome-icon class="ml-1" icon="fa-regular fa-play-circle"></font-awesome-icon>
                </slot>
            </v-btn>
        </template>

        <v-card>
            <CreatomatePreview
                ref="creatomatePreview"
                :source="state.preview.source"
                :modifications="state.preview.mods"
                :with-resize-observer="false"
            />

            <!-- <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" text @click="closePreview">Close</v-btn>
            </v-card-actions> -->
        </v-card>
    </v-dialog>
</template>

<script>
import CreatomatePreview from '@/components/Tribute/Themes/CreatomatePreview.vue';
import { tributePerformanceModeEnum } from '../../../constants';

export default {
    name: 'MobilePreview',
    components: { CreatomatePreview },
    inject: ['state'],
    data() {
        return {
            previewActive: false
        }
    },
    methods: {
        closePreview() {
            // pause preview on close
            this.previewActive = false;
            const previewInstance = this.$refs.creatomatePreview;
            if (previewInstance && previewInstance.pauseVideo) {
                previewInstance.pauseVideo();
            }
        }
    },
    watch: {
        async previewActive(newVal, oldVal) {
            if (newVal && newVal !== oldVal) {
                const previewInstance = this.$refs.creatomatePreview;
                await this.$nextTick();
                if (previewInstance?.initReload && this.state.performanceMode !== tributePerformanceModeEnum.FEATURES) {
                    console.log('refreshing preview');
                    previewInstance.initReload();
                }
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.preview-btn {
    &::v-deep {
        border-color: $medium-gray;
        padding: 0 8px !important;
        .v-btn__content {
            letter-spacing: normal;
            text-transform: capitalize;
            color: $deep-gray;
        }
    }
}
// .text-normal {
// }
</style>
